export default "__VITE_ASSET__756bf627__"